module.exports = __webpack_public_path__ + "static/wff-sec5-01-a9c8528a26a33e6cf1e1fb1d309e96a0.jpg";